module.exports = __webpack_public_path__ + "static/img/wx-code.05aa5a1d.jpg";